import React from "react";
import ForgetPasswordForm from "./components/ForgetPasswordForm";

const ForgotPassword = () => {
  return (
    <>
      <div>
        <div className="text-center">
          <h4 className="mb-0"> Forgot your password?</h4>
          <small>Enter your email and we'll send you a reset link.</small>
        </div>
        <ForgetPasswordForm />
      </div>
    </>
  );
};

export default ForgotPassword;
